import TrackItem from "./TrackItem";

export default function SetCard({
  set,
  setIndex,
  isCollapsed,
  onToggleCollapse,
  currentTrack,
  onTrackClick,
  tooltipState,
  onTrackHover,
}) {
  return (
    <div className={`set-card ${isCollapsed ? "collapsed" : ""}`}>
      <div className="set-header" onClick={() => onToggleCollapse(setIndex)}>
        <h2>
          {set.label}
          <span className="set-toggle-icon">▼</span>
        </h2>
        <div className="set-stats">
          <span>{set.duration_label}</span>
          <span>{set.songs.length} songs</span>
        </div>
      </div>
      <ol className={`track-list ${isCollapsed ? "collapsed" : ""}`}>
        {set.tracks &&
          set.tracks.map((track, trackIndex) => {
            const nextTrack = set.tracks?.[trackIndex + 1];
            return (
              <TrackItem
                key={trackIndex}
                track={track}
                nextTrack={nextTrack}
                isPlaying={currentTrack?.mp3_url === track.mp3_url}
                tooltipState={tooltipState}
                onTrackClick={onTrackClick}
                onTrackHover={onTrackHover}
              />
            );
          })}
      </ol>
    </div>
  );
}
